<div class="playlist-item library-item" (contextmenu)="$event.preventDefault()" (mouseenter)="isHover = true"
  (mouseleave)="isHover = false">

  <mat-icon class="green" *ngIf="playlist.IsAndroid"
    matTooltip="Android playlists can be assigned only to android devices screens" svgIcon="playlist_play"></mat-icon>
  <mat-icon class="blue" *ngIf="playlist.MachinePhysicalAddress && !playlist.IsAndroid"
    matTooltip="Local playlists can be assigned only to the created location" svgIcon="playlist_play"></mat-icon>
  <mat-icon *ngIf="!playlist.MachinePhysicalAddress && !playlist.IsAndroid" matTooltip="Global playlists can be assigned to any screen"
    svgIcon="playlist_play"></mat-icon>
  <span class="title" [matTooltip]="playlist.PlaylistTitle">{{playlist.PlaylistTitle}}</span>
  <div class="float-right">
    <mat-icon *ngIf="userId && playlist.UserId == userId" (click)="delete()" [hidden]="!isHover" class="action-button"
      svgIcon="close" matTooltip="Delete Playlist">
    </mat-icon>
    <mat-icon (click)="edit()" [hidden]="!isHover" class="action-button edit-button" svgIcon="edit"
      matTooltip="Edit Playlist"></mat-icon>
    <mat-icon (click)="copy()" [hidden]="!isHover" class="action-button" svgIcon="content_copy"
      matTooltip="Duplicate Playlist"></mat-icon>
    <mat-icon (click)="play()" [hidden]="!isHover" class="action-button" svgIcon="play_arrow"
      matTooltip="Start Playlist" [class.disabled]="isAnyScreenPending"></mat-icon>
  </div>
  <div *ngIf="playlist.MachinePhysicalAddress">
    <p class="playlist-location">Location:
      <span [matTooltip]="playlist.Machine?.Title">{{playlist.Machine?.Title}}</span>
    </p>
  </div>
</div>
